import useInteractiveWidgetSubmit from '../../hooks/useInteractiveWidgetSubmit';
import {SocialMediaSelector} from '../../../../shared/campaign/SocialMediaSelector';
import {useCampaignRuntimeContext} from '../../context/CampaignRuntimeContext';
import {getArtScheduleKey} from '../../../../shared/campaign/utils/scheduleDateTime';
import {normalizeNetworkList} from '../../../../shared/campaign/utils/socialNetworkMapper';
import {
  buildSocialNetworksCompletionMessage,
  CAMPAIGN_WIDGET_TOOL_NAMES,
} from '../../utils/campaignCompletionMessages';
import {
  buildSocialMediaSettings,
  extractNetworkNames,
} from '../../utils/socialSelection';

export default function SocialMediaIntegration({
  networks = [],
  isReadOnly = false,
  toolCallId = null,
}) {
  const {runtime, setArtScheduleData, setSocialScheduleContext} =
    useCampaignRuntimeContext();
  const artResults = runtime.content.arts;

  const {handleSubmit: handleComplete, isPending} = useInteractiveWidgetSubmit(
    CAMPAIGN_WIDGET_TOOL_NAMES.REDES_SOCIAIS,
    toolCallId,
    (data) =>
      buildSocialNetworksCompletionMessage(
        data.socialSelection || data.networks || [],
      ),
  );

  return (
    <SocialMediaSelector
      initialSelection={networks}
      isReadOnly={isReadOnly || isPending}
      onFinalize={(selectedNetworks) => {
        if (isReadOnly || isPending) return;

        const socialSelection = (selectedNetworks || []).filter(Boolean);
        const normalizedNetworks = normalizeNetworkList(
          extractNetworkNames(socialSelection),
        );
        const socialMediaSettings = buildSocialMediaSettings(socialSelection);

        setSocialScheduleContext({
          selectedNetworks: normalizedNetworks,
          socialMediaSettings,
          socialSelection,
        });

        setArtScheduleData((prev) => {
          const updated = {...prev};
          artResults.forEach((art, index) => {
            const artKey = getArtScheduleKey(art, index);
            if (!updated[artKey]) {
              updated[artKey] = {};
            }
            updated[artKey] = {
              ...updated[artKey],
              selectedNetworks: normalizedNetworks,
              socialMediaSettings,
            };
          });
          return updated;
        });

        handleComplete({
          networks: normalizedNetworks,
          socialSelection,
        });
      }}
    />
  );
}
